import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

const UserRoleManagement = () => {

    

    const { roleId } = useParams();

    console.log("Role Id:", roleId);



const [users, setUsers] = useState([]);
const [roles, setRoles] = useState([]);
const [message, setMessage] = useState("");
const [alertType, setAlertType] = useState("success");
const API_URL = process.env.REACT_APP_API_URL;

useEffect(() => {

    if (roleId) {
        getUsersByRole();
    }

    getRoles();

}, [roleId]);

const getUsersByRole = async () => {

    try {

        const res = await axios.get(
            `${API_URL}api/admin/user-role-management/${roleId}`
        );

        console.log(
            "Users Data =>",
            res.data
        );

        setUsers(res.data.data);

    } catch (error) {

        console.log(error);

    }

};

const getRoles = async () => {

    try {

        const res = await axios.get(
            `${API_URL}api/roles`
        );

        setRoles(res.data.data);

    } catch (error) {

        console.log(error);
    }
};

const updateRole = async (docId, roleId) => {

    try {

        const selectedRole = roles.find(
            (role) => String(role.role_id) === String(roleId)
        );

        await axios.put(
            `${API_URL}api/update-user-role`,
            {
                docId,
                role_id: selectedRole.role_id,
                role_name: selectedRole.role_name
            }
        );

        setAlertType("success");
        setMessage("Role ID Updated Successfully");

        setTimeout(() => {
            setMessage("");
        }, 3000);

        getUsersByRole();

    } catch (error) {

        console.log(error);

        setAlertType("danger");
        setMessage("Failed To Update Role ID");

        setTimeout(() => {
            setMessage("");
        }, 3000);

    }

};

return (
    <div className="container-fluid">

        <div className="card shadow-sm">

            <div className="card-header">
                <h4 className="text-center mb-0">
                    User Role Management
                </h4>
            </div>

            <div className="card-body">

                {
    message && (
        <div
            className={`alert alert-${alertType} alert-dismissible fade show`}
            role="alert"
        >
            {message}

            <button
                type="button"
                className="btn-close"
                onClick={() => setMessage("")}
            ></button>
        </div>
    )
}

                <div className="table-responsive">

                    <table className="table table-bordered table-hover">

                        <thead>
    <tr>
        <th>S.No</th>
        <th>User ID</th>
        <th>User Name</th>
        <th>Email</th>
        <th>Role Name</th>
    </tr>
</thead>

   <tbody>

{
    users.length > 0 ? (

        users.map((user, index) => (

            <tr key={user.id}>

                <td>{index + 1}</td>

                <td>{user.user_id}</td>

                <td>{user.full_name}</td>

                <td>{user.email}</td>

                <td>
                    {
                        Array.isArray(user.roles) &&
                        user.roles.length > 0
                            ? user.roles.map(
                                (role) =>
                                    role.role_name
                              ).join(", ")
                            : user.role_name
                    }
                </td>

            </tr>

        ))

    ) : (

        <tr>

            <td
                colSpan="5"
                className="text-center"
            >
                No Users Found
            </td>

        </tr>

    )
}

</tbody>

                    </table>

                </div>

            </div>

        </div>

    </div>
);


};

export default UserRoleManagement;
